import React, { Component } from 'react';
import {Container} from 'reactstrap';



class PrivacyPolicy extends Component {
  render() {
    return (
      <div>
    
    <Container className="pt-lg-5 mt-lg-5">
        <h1>Privacy Policy</h1>
      </Container>
        <Container style={{marginTop: '2rem', marginBottom: '2rem'}}>
        <p>Lighthouse Digital, LLC owns the website atlighthouse.com (herein referred to as the “Service”). This page informs you of our policies regarding the collection, use and disclosure of Personal Information when you use our Service. We will not use or share your information with anyone except as described in this Privacy Policy. We use your Personal Information for providing and improving the Service. By using the Service, you agree to the collection and use of information in accordance with this policy.
        <br /><br />

        <b>Information Collection And Use</b>

        <br /><br />
        While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to, your email address, name, phone number, postal address (“Personal Information”).
        
        <br /><br />
        We collect this information for the purpose of providing the Service, identifying and communicating with you, responding to your requests/inquiries, servicing your purchase orders, and improving our services.
        
        <br /><br />
        If you subscribe or purchase any product or course offered by the Company or one of its subsidiaries, you will enter into a new agreement with privacy provisions. In that case, the new agreement will contain new terms that apply to the information you provide us in the course of your use of the product of course.
        
        <br /><br />
        
        <b>Logo Data</b>
        
        <br /><br />
        We collect information that your browser sends whenever you visit our Service (“Log Data”). This Log Data may include information such as your computer’s Internet Protocol (“IP”) address, browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages and other statistics.
        
        <br /><br />
        In addition, we may use third party services such as Google Analytics that collect, monitor and analyze this type of information in order to increase our Service’s functionality. These third party service providers have their own privacy policies addressing how they use such information.
        
        <br /><br />
        
        <b>Cookies</b>
        
        <br /><br />
        Cookies are files with a small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and transferred to your device. We use cookies to collect information in order to improve our services for you.

        <br /><br /> 
        You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. The Help feature on most browsers provide information on how to accept cookies, disable cookies or to notify you when receiving a new cookie.
        
        <br /><br />
        If you do not accept cookies, you may not be able to use some features of our Service and we recommend that you leave them turned on.
        
        <br /><br />
          
        <b>Behavioral Remarketing</b>

        <br /><br />  
        Lighthouse uses remarketing services to advertise on third party web sites to you after you visited our Service. We, and our third party vendors, use cookies to inform, optimize and serve ads based on your past visits to our Service.
        <br /><br />
          
        <b>Google</b>
        
        <br /><br />
        Google AdWords remarketing service is provided by Google Inc. You can opt-out of Google Analytics for Display Advertising and customize the Google Display Network ads by visiting the Google Ads Settings page. Google also recommends installing the Google Analytics Opt-out Browser Add-on for your web browser. Google Analytics Opt-out Browser Add-on provides visitors with the ability to prevent their data from being collected and used by Google Analytics. For more information on the privacy practices of Google, please visit the Google Privacy & Terms web page.
        <br /><br />
      
        <b>AdRoll</b>
          
        <br /><br />
        AdRoll remarketing service is provided by Semantic Sugar, Inc. You can opt-out of AdRoll remarketing by visiting this AdRoll Advertising Preferences web page. For more information on the privacy practices of AdRoll, please visit the AdRoll Privacy Policy web page.
        <br /><br />
          
        <b>Service Providers</b>
          
        <br /><br />
        We may employ third party companies and individuals to facilitate our Service, to provide the Service on our behalf, to perform Service-related services and/or to assist us in analyzing how our Service is used.
        
        <br /><br />
        These third parties have access to your Personal Information only to perform specific tasks on our behalf and are obligated not to disclose or use your information for any other purpose.
        <br /><br />
          
        <b>Communications</b>
          
        <br /><br />
        We may use your Personal Information to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the Opt Out link or instructions provided in any email we send.
        <br /><br />
          
        <b>Compliance With Laws</b>
          
        <br /><br />
        We will disclose your Personal Information where required to do so by law or subpoena or if we believe that such action is necessary to comply with the law and the reasonable requests of law enforcement or to protect the security or integrity of our Service.
        <br /><br />
          
        <b>Security</b>
        
        <br /><br />
        The security of your Personal Information is important to us, and we strive to implement and maintain reasonable, commercially acceptable security procedures and practices appropriate to the nature of the information we store, in order to protect it from unauthorized access, destruction, use, modification, or disclosure. We may store your Log Data for an indefinite amount of time.
        
        <br /><br />
        However, please be aware that no method of transmission over the internet, or method of electronic storage is 100% secure and we are unable to guarantee the absolute security of the Personal Information we have collected from you.
        <br /><br />
          
        <b>International Transfer</b>
          
        <br /><br />
        Your information, including Personal Information, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction. If you are located outside United States and choose to provide information to us, please note that we transfer the information, including Personal Information, to United States and process it there.
        
        <br /><br />
        Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.
        <br /><br />
          
        <b>Links To Other Sites</b>
          
        <br /><br />
        Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party’s site. We strongly advise you to review the Privacy Policy of every site you visit.
        <br /><br />
        We have no control over, and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
        <br /><br />
          
        <b>Children’s Privacy</b>
          
        <br /><br />
        Only persons age 18 or older have permission to access our Service. Our Service does not address anyone under the age of 13 (“Children”).
        
        <br /><br />
        We do not knowingly collect personally identifiable information from children under 13. If you are a parent or guardian and you learn that your Children have provided us with Personal Information, please contact us.
        <br /><br /> 
        
        <b>Changes To This Privacy Policy</b>
          
        <br /><br /> 
        This Privacy Policy is effective as of August 12th, 2019 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.
        
        <br /><br /> 
        We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.
        <br /><br /> 
          
        <b>Contact Us</b>
        
        <br /><br /> 
        If you have any questions about this Privacy Policy, please contact us at:
        
        <br /><br /> 
          Lighthouse Digital, LLC
          <br />
          3550 Lenox Rd NE, 
          <br />
          Atlanta, GA 30326</p>
          </Container>
      </div>
    )
  }
}

export default PrivacyPolicy;
